/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { JobLettersRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';
import { LetterTemplateAvailability, LetterTemplateAvailabilityRequest } from './job-letters.model';

@Injectable()
export class JobLetterListTabBusinessService implements InitViewService {
  constructor(private jobLettersRest: JobLettersRestService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      jobLetters: this.findAll(),
    };
  }

  update(letterTemplate: LetterTemplateAvailability): Observable<LetterTemplateAvailabilityRequest> {
    const data = {
      fileNames: letterTemplate.list.filter((item) => item.isAvailable).map((item) => item.fileName),
      version: letterTemplate.version,
    };

    return this.jobLettersRest.update(data);
  }

  findAll(): Observable<LetterTemplateAvailability> {
    return this.jobLettersRest.findAll();
  }
}
